import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ai-product_content flex-column align-center" }
const _hoisted_2 = { class: "tips-box" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "generate-content"
}
const _hoisted_5 = {
  key: 0,
  class: "generate-content_content"
}
const _hoisted_6 = { class: "essay-box" }
const _hoisted_7 = { class: "essay-box-tools" }
const _hoisted_8 = { class: "essay-box-tools_text" }
const _hoisted_9 = { class: "content_empty" }
const _hoisted_10 = { class: "content_empty_div" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "iconfont icon-tingzhi essay-button_icon"
}
const _hoisted_13 = {
  key: 1,
  class: "iconfont icon-runse essay-button_icon"
}

import { alertController, IonInput, IonPage, modalController } from "@ionic/vue";
import { BRAND_IMAGES, getBrandImageUrl } from "@/js/brandImages";

import { useRoute, useRouter } from "vue-router";
import { nextTick, onMounted, reactive, ref, watch } from "vue";
import tools from "@/js/tools";
import requestApi from "@/js/http";
import http from "@/js/http";
import WinRecord from "@/js/Record";
import store from "@/js/store";
import PageWhiteBackground from "@/components/PageWhiteBackground.vue";
import { openMsgToast } from "@/views/AIGenerate/openModal";
import { useStorage, useToggle } from "@vueuse/core";
import TextAnalysis from "@/views/AIGenerate/components/TextAnalysis.vue";
import SafeWord from "@/components/SafeWord.vue";
import aiLoading from "@/components/aiLoading.vue";
import { aiUsageLimit } from "@/js/aiUsageLimit";

const audio_url = "http://47.254.121.216:6039/api/speechMsg";
const audio_file_url = "http://47.254.121.216:6039/";
const authorization =
  "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOiJzeXNfdXNlcjoxNzM3NjY0OTMyNDI2MTU4MDgxIiwicm5TdHIiOiJOMlFWMnNDdzh2TmdQSllVNFRheUlFeWdyVUtHb0lBZCIsInRlbmFudElkIjoiMDAwMDAiLCJ1c2VySWQiOjE3Mzc2NjQ5MzI0MjYxNTgwODF9.YExs672d7euNs27Xsl5aum5433AJEMYum9fpOYdC3zA";

interface Props {
  question?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'smartAnalysis',
  props: {
    question: {}
  },
  setup(__props: any) {

const server_url = `${http.aiUrl}/gpt/sseChatPrompt`;
const record = ref<any>(null);
const router = useRouter();
const route = useRoute();
const params = ref<any>();
const aiLoadingRef = ref();
const textComponent2 = ref<any>();
const markdownRef = ref<any>();
const props = __props;
const userInfo = useStorage("userinfo", {});
const brandImages = BRAND_IMAGES;
const baseData = reactive<any>({
  title: "",
  // 选择题
  testPaperData: [],
  // 问答题
  questionsAndAnswersData: {},
  questionsAnswersResData: "",
  // 完形填空
  clozeData: {},
  question: "",
  aiType: "",
  audioUrl: "",
  audioPlayState: true,
  audioFile: null,
  markdownDom: null,
  conversationId: "", // chatGpt会话id
});

const httpController = ref<any>();
const [isLoading, changeIsloading] = useToggle();
const externalSource = ref(false);

/**
 * 【AI词典大全】 OPENAI_PROMPT_WORDLIST
 * 【AI语法分析】OPENAI_PROMPT_ANALYZEGRAMAR
 * 【AI校对文章】 OPENAI_PROMPT_PROOFREAD_ARTICLE
 * 【AI短文】（1）OPENAI_PROMPT_READPASSAGE （2） OPENAI_PROMPT_READPASSAGE_V1 新
 * 【AI对话练习】 OPENAI_PROMPT_VOICE_CONVERSATION
 * 【AI阅读理解】 OPENAI_PROMPT_EXAMPAPER_QA
 * 【AI短句训练】 OPENAI_PROMPT_SHORT_SENTENCE
 */

async function routerBack() {
  nextTick(() => {
    baseData.questionsAnswersResData = "";
    httpController.value?.abort("终止请求"); // 终止请求
  });
  if (props.question) {
    await modalController.dismiss("cancel");
  } else {
    router.go(-1);
  }
}

// 请求gpt
async function postChatMessage() {
  if (isLoading.value) {
    handleStop();
    return;
  }
  if (!baseData.question) {
    await openMsgToast("请输入内容");
    return;
  }

  if (baseData.question.match(/[\u4e00-\u9fa5]/g)) {
    await openMsgToast("不允许输入中文字符");
    return;
  }

  /* eslint-disable */
  // 限制所有特殊字符出现3次以上
  if (
    baseData.question.match(
      /[-!@#$%^&*()<>?:"{}|`,.;'~！、￥……”“‘’；：。，、】【=——+￡￠\/\\[\]]{4,}/g
    )
  ) {
    await openMsgToast(`存在非法字符，请仔细检查`);
    return;
  }

  baseData.questionsAnswersResData = "";
  httpController.value?.abort("终止请求");

  const signal = getHttpControllerSignal();
  changeIsloading(true);
  await nextTick(() => {
    aiLoadingRef.value && aiLoadingRef.value.open();
  });
  const serverKey = "OPENAI_PROMPT_ANALYZEGRAMAR";
  const requestParams = {
    userSubmitId: userInfo.value?.schoolId,
    userKey: "",
    serverKey: serverKey,
    conversationId: new Date().getTime(),
    prompt: baseData.question || "", // baseData.question
    promptParameter: { grade: "", wordCount: "" },
    options: {},
    usingContext: true,
    topP: 1,
    contentNumber: 10,
    filterSensitive: true,
  };
  try {
    const usageLimit = await aiUsageLimit(serverKey);
    // textComponent.value.modifyWordStylePlugin(baseData.question) // 根据输入的单词动态修改markdown样式
    if (usageLimit) {
      http.get("/Ai/getAiToken").then(async (res) => {
        if (res.data.code === 200) {
          const userKey = res.data.data;
          const resData = await fetch(`${http.aiUrl}/gpt/sseChatPrompt`, {
            method: "POST",
            body: JSON.stringify({ ...requestParams, userKey: userKey }),
            headers: { "content-type": "application/json" },
            signal,
          });
          await analysisStreamData(resData);
        } else {
          changeIsloading(false);
          aiLoadingRef.value && aiLoadingRef.value.close();
        }
      });
    } else {
      changeIsloading(false);
    }
  } catch (err) {
    changeIsloading(false);
    aiLoadingRef.value && aiLoadingRef.value.close();
  }
}

// 解析 stream 流文件
async function analysisStreamData(resData: any) {
  const reader = (resData.body?.getReader() as any) || {};
  const decoder = new TextDecoder();
  const flag = true;
  await handleElseResStrData(flag, reader, decoder);
}

function getMarkdownCallback(callback: any) {
  callback(baseData.question);
}

async function handleElseResStrData(flag: any, reader: any, decoder: any) {
  while (flag) {
    let { done, value } = (await reader?.read()) as any;
    if (done) {
      changeIsloading(false);
      if (
        baseData.questionsAnswersResData.includes("code") &&
        baseData.questionsAnswersResData.includes("5001")
      ) {
        const modal = await modalController.create({
          component: SafeWord,
          componentProps: {
            msg: JSON.parse(baseData.questionsAnswersResData).msg,
          },
          cssClass: "common_center_modal_container_transparent",
        });
        await modal.present();
        await modal.dismiss();
        baseData.questionsAnswersResData = "";
      }
      break;
    }
    const txt = decoder.decode(value);
    baseData.questionsAnswersResData += txt;
    aiLoadingRef.value && aiLoadingRef.value.close();
  }
}

// 根据返回接口生成音频文件并播放
function getAudioUrl(signal: any) {
  if (baseData.audioFile) {
    baseData.audioFile.pause();
    baseData.audioFile = null;
  }
  baseData.audioUrl = "";
  const conversationParams = {
    msgId: new Date().getTime(),
    msg: baseData.question,
    signal: signal,
  };
  requestApi.post(audio_url, conversationParams).then((res) => {
    if (res?.data?.code === 200) {
      baseData.audioUrl = audio_file_url + res.data.msg || "";
      baseData.audioFile = new Audio(baseData.audioUrl) as any;

      // 获取音频文件立即播放
      if (baseData.audioFile) {
        baseData.audioFile.play();
        baseData.audioPlayState = false;
      }
      handleAudioEndEvent();
    }
  });
}

// 点击播放 or 暂停播放
async function audioPlay() {
  if (baseData.audioFile) {
    // load() 重新加载
    // 播放
    if (baseData.audioPlayState) {
      baseData.audioFile.play();
      baseData.audioPlayState = false;
    } else {
      // 停止播放
      baseData.audioFile.pause();
      baseData.audioPlayState = true;
    }
  } else {
    alertPopOverDialog("暂无音频文件，请稍等...");
  }
}

// 监听音频文件播放结束
function handleAudioEndEvent() {
  if (baseData.audioFile) {
    baseData.audioFile.addEventListener("ended", () => {
      baseData.audioPlayState = true;
    });
  }
}

// 弹窗组件
async function alertPopOverDialog(msg: string) {
  const alert = await alertController.create({
    subHeader: msg,
    buttons: [],
  });
  await alert.present();
}

// 下拉刷新页面
function doRefresh(RefreshAnimationEvent: any) {
  tools.closeRefreshAnimation(RefreshAnimationEvent, 200);
  initPageInfo();
}

// 点击页面返回按钮 返回首页
function navigateBackHomePage() {
  router.back();
  // router.push('/TeacherIndex')
  // 音频文件停止播放
  if (baseData.audioFile) {
    baseData.audioFile.pause();
    baseData.audioFile = null;
    baseData.audioPlayState = true;
  }

  nextTick(() => {
    baseData.questionsAnswersResData = "";
    httpController.value?.abort("终止请求"); // 终止请求
  });
}

function getHttpControllerSignal() {
  httpController.value = new AbortController();
  const { signal } = httpController.value;
  return signal;
}

function getAudioGptAnswer(rData: string) {
  const signal = getHttpControllerSignal();
  baseData.question = rData ? rData?.data : "";
  // baseData.question = 'What day is it today'
  getAudioUrl(signal);
}

function initPageInfo() {
  baseData.questionsAnswersResData = "";
  baseData.conversationId = new Date().getTime();
  switch (params.value) {
    case "dictionary":
      baseData.title = "AI词典";
      baseData.aiType = "OPENAI_PROMPT_WORDLIST";
      break;
    case "grammar":
      baseData.title = "AI语法";
      baseData.aiType = "OPENAI_PROMPT_PROOFREAD_ARTICLE"; // 校对文章
      // baseData.aiType = 'OPENAI_PROMPT_ANALYZEGRAMAR'
      break;
    case "articles":
      baseData.title = "AI语法";
      baseData.aiType = "OPENAI_PROMPT_ANALYZEGRAMAR"; // 语法分析
      // baseData.aiType = 'OPENAI_PROMPT_PROOFREAD_ARTICLE'
      break;
    case "shortArticle":
      baseData.title = "AI短文";
      // baseData.aiType = 'OPENAI_PROMPT_READPASSAGE'
      baseData.aiType = "OPENAI_PROMPT_READPASSAGE_V1";
      break;
    case "dialogue":
      baseData.title = "AI听力";
      baseData.aiType = "OPENAI_PROMPT_LISTENINGPRACTICE";
      break;
    case "comprehension":
      baseData.title = "AI智阅";
      // baseData.aiType = 'OPENAI_PROMPT_EXAMPAPER_QA' // App 没有选择题 根据单词或句子拓展内容
      // baseData.aiType = 'OPENAI_PROMPT_EXAMPAPER_QA_PC' // PC 根据学过的单词生成短文和问题
      baseData.aiType = "OPENAI_PROMPT_EXAMPAPER_QA_APP"; // PC 根据学过的单词生成短文和问题
      break;
    case "sentenceTraining":
      baseData.title = "AI短句训练";
      baseData.aiType = "OPENAI_PROMPT_SHORT_SENTENCE";
      break;
    case "voiceConversation":
      baseData.title = "AI听口";
      baseData.aiType = "OPENAI_PROMPT_VOICE_CONVERSATION";
      break;
    default:
      return;
  }
}

function initRecord() {
  const isMobile = store.isMobile();

  // 判断是否是手机端
  if (isMobile) {
    // record.value = new Record() // 手机 html5 录音
    record.value = new WinRecord(audio_file_url);
  } else {
    record.value = new WinRecord(audio_file_url);
  }
}

function handleStop() {
  httpController.value?.abort();
  changeIsloading(false);
  aiLoadingRef.value.close();
  baseData.questionsAnswersResData = "";
}

function handleWindowLocationParamsValue() {
  const pathname = window.location.pathname;
  const regex = /^\/ai-generate\/(.*)$/;
  const match = pathname.match(regex);
  if (match) {
    params.value = match[1];
  }
}

watch(
  () => props.question,
  () => {
    if (props.question) {
      baseData.question = props.question;
      postChatMessage();
    }
  },
  { immediate: true }
);

onMounted(() => {
  if (route.query && route.query.source) {
    externalSource.value = route.query.source === "external";
  }
  handleWindowLocationParamsValue();
  initPageInfo();
  initRecord();
  handleAudioEndEvent();
  baseData.markdownDom = document.querySelector(".markdown-body2") as any;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), { class: "ai-product" }, {
    default: _withCtx(() => [
      _createVNode(PageWhiteBackground, {
        title: _unref(userInfo).userType == 1 ? 'AI语法' : 'AI语法',
        "background-color": {
        background:
          '#F1F6FF url(' +
          _unref(getBrandImageUrl)('ai_smart_reading/analysis_bg.png') +
          ') no-repeat 0 0/100% 100%',
      },
        "router-type": 'modal',
        "external-source": externalSource.value,
        onRouterBack: routerBack
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "tips-box-left" }, [
                _createElementVNode("div", { class: "tips-box-left-title" }, "智能语言的语法之谜"),
                _createElementVNode("div", { class: "tips-box-left-tip" }, "解锁深层智慧")
              ], -1)),
              _createElementVNode("img", {
                class: "tips-box-right",
                src: _unref(getBrandImageUrl)('ai_smart_reading/analysis_img.png'),
                alt: ""
              }, null, 8, _hoisted_3)
            ]),
            (params.value !== 'dialogue' && params.value !== 'voiceConversation')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (!baseData.questionsAnswersResData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((baseData.question) = $event)),
                            maxlength: "2000",
                            placeholder: "请输入您要解析的短句",
                            class: "essay-box-text"
                          }, "                ", 512), [
                            [_vModelText, baseData.question]
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _withDirectives(_createElementVNode("i", {
                              class: "iconfont icon-qingkong essay-box-tools_icon",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (baseData.question = ''))
                            }, null, 512), [
                              [_vShow, baseData?.question?.length]
                            ]),
                            _createElementVNode("div", _hoisted_8, _toDisplayString(baseData?.question.length ?? 0) + "/2000", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("img", {
                              src: _unref(getBrandImageUrl)('ai_smart_reading/analysis_empty.png'),
                              alt: ""
                            }, null, 8, _hoisted_11),
                            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "content_empty_div_title" }, "开始试试吧", -1))
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createBlock(TextAnalysis, {
                        key: 1,
                        ref_key: "textComponent2",
                        ref: textComponent2,
                        "generate-type": "vocabulary",
                        "as-raw-text": false,
                        inversion: false,
                        text: baseData.questionsAnswersResData,
                        "prop-word": baseData.question,
                        onGetMarkdownCallback: getMarkdownCallback,
                        onClear: handleStop
                      }, null, 8, ["text", "prop-word"]))
                ]))
              : _createCommentVNode("", true),
            (!baseData.questionsAnswersResData)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "essay-button button-ripple",
                  onClick: postChatMessage
                }, [
                  (_unref(isLoading))
                    ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                    : (_openBlock(), _createElementBlock("i", _hoisted_13)),
                  _createTextVNode(" " + _toDisplayString(_unref(isLoading) ? "停止智析" : "一键智析"), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["title", "background-color", "external-source"]),
      _createVNode(aiLoading, {
        ref_key: "aiLoadingRef",
        ref: aiLoadingRef
      }, null, 512)
    ]),
    _: 1
  }))
}
}

})